<template>
  <ul class="wrap">
    <g-header :navActive="1"></g-header>
    <ul class="content">
      <div class="g-block-title light" style="padding: 60px 0 50px">
        <p class="name">服务模式</p>
        <p class="line"></p>
        <p class="en-name">SERVICE MODE</p>
      </div>
      <div class="title">
        <!-- <div class="fang" ></div> -->
        <p
          :style="{'background-color': titleActive===0?'#ffffff':'transparent', color: titleActive===0?'#7062ed':'#ffffff'}"
          @mouseover="titleActive=0"
        >统筹架构</p>
        <p
          :style="{'background-color': titleActive===1?'#ffffff':'transparent', color: titleActive===1?'#7062ed':'#ffffff'}"
          @mouseover="titleActive=1"
        >场景定制</p>
      </div>
      <ul class="content-wrap g-clear-float">
        <transition name="fade" mode="out-in">
          <ul class="text-wrap" v-if="titleActive===0" key="text1">
            <ul class="list">
              <li class="item" v-for="(item,index) in list1" :key="index">{{item}}</li>
            </ul>
          </ul>
          <div class="text-wrap" v-else key="text2">
            <ul class="list">
              <li class="item" v-for="(item,index) in list2" :key="index">{{item}}</li>
            </ul>
          </div>
        </transition>

        <transition name="fade" mode="out-in">
          <div class="img-wrap" v-if="titleActive===0" key="img1">
            <img :src="item" v-for="(item,index) in imgs1" :key="index" />
          </div>
          <div class="img-wrap" v-else key="img2">
            <img :src="item" v-for="(item,index) in imgs2" :key="index" />
          </div>
        </transition>
      </ul>
    </ul>
    <g-footer></g-footer>
  </ul>
</template>
<script>
export default {
  name: "service",
  data() {
    return {
      titleActive: 0,
      list1: [
        "依据覆盖统筹区域对医保支付的药械销售和使用的全部场景进行设计和部署",
        "本地化部署药械鉴核数据平台",
        "统筹规划药械鉴核系统与医保经办系统/智能审核系统/药械招采系统/两定机构业务系统的数据衔接"
      ],
      imgs1: [
        require("./imgs/1.png"),
        require("./imgs/2.png"),
        require("./imgs/3.png"),
        require("./imgs/4.png")
      ],
      list2: [
        "依据统筹区域一个或几个特定的药械销售和使用的医保支付场景进行设计与实现。（如高值药械的鉴核监管、开通慢特病药事服务的门诊和药店鉴核监管、互联网+医保用药支付等特定场景）",
        "药械鉴核过程可以嵌入到相关场景的某个环节，可以通过数据交互方式对接到相关场景下的业务系统，并将鉴核结果数据保留在相应的系统中。"
      ],
      imgs2: [
        require("./imgs/5.png"),
        require("./imgs/6.png"),
        require("./imgs/7.png"),
        require("./imgs/8.png")
      ]
    };
  },
  mounted() {
    this.$nextTick(() => {
      document.getElementById("app").scrollTop = 0;
    });
  }
};
</script>
<style lang="stylus" scoped>
.wrap {
  margin-top: 60px;

  .content {
    background: url('./imgs/bj.jpg') no-repeat;
    background-size: 100% 100%;

    .title {
      width: 1190px;
      margin: 0 auto;
      font-size: 0;
      border: solid 2px #ffffff;
      box-sizing: border-box;
      position: relative;
      overflow: hidden;
      cursor: default;

      .fang {
        content: '';
        width: 120px;
        height: 120px;
        background-color: #ffffff;
        position: absolute;
        left: 50%;
        top: 25px;
        transform: translateX(-50%) rotate(45deg);
        transition all .5s
        z-index 2
      }

      p {
        display: inline-block;
        vertical-align: top;
        line-height: 80px;
        width: 50%;
        text-align: center;
        font-size: 26px;
        transition: all 0.5s;
      }
    }

    .content-wrap {
      width: 1190px;
      margin: 88px auto 0;
      padding-bottom: 80px;

      .text-wrap {
        float: left;
        width: 450px;

        .list {
          .item {
            color: #ffffff;
            font-size: 26px;
            padding-left: 25px;
            position: relative;
            margin-bottom: 60px;
            text-align: justify;

            &:last-child {
              margin-bottom: 0;
            }

            &::before {
              content: '';
              position: absolute;
              left: 0;
              top: 12px;
              width: 15px;
              height: 15px;
              background-color: #ffffff;
            }
          }
        }
      }

      .img-wrap {
        float: right;
        width: 658px;

        img {
          display: inline-block;
          vertical-align: top;
          width: 307px;
          margin: 0 28px 28px 0;
          border-radius: 10px;
          box-shadow: 15px 15px 0 0px #24478d;

          &:nth-child(even) {
            margin-right: 0;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/service/index.vue